export enum SmartDealDocumentState {
  Draft = 'Draft',
  Blockchain = 'Blockchain',
  Approved = 'Approved',
}

